import { Icon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface PayrollEmployeeDataCategory {
  name: string
  illustration: React.ComponentProps<typeof Icon.Large>['icon']
  title: string
  description: string
}

// This is a temporal solution. We should see how to dynamically load this categories from the backend.
export const getPayrollEmployeeCategories = (): PayrollEmployeeDataCategory[] => [
  {
    name: 'permits_and_certificates',
    illustration: 'document-handshake',
    title: i18n.t('employee_form.payroll_data.categories.permits_and_certificates.title'),
    description: i18n.t(
      'employee_form.payroll_data.categories.permits_and_certificates.description'
    ),
  },
  {
    name: 'social_insurances',
    illustration: 'red-cross',
    title: i18n.t('employee_form.payroll_data.categories.social_insurances.title'),
    description: i18n.t('employee_form.payroll_data.categories.social_insurances.description'),
  },
  {
    name: 'taxes_and_deductions',
    illustration: 'money-spreadsheet',
    title: i18n.t('employee_form.payroll_data.categories.taxes_and_deductions.title'),
    description: i18n.t('employee_form.payroll_data.categories.taxes_and_deductions.description'),
  },
  {
    name: 'work_activity',
    illustration: 'single-neutral-actions-process',
    title: i18n.t('employee_form.payroll_data.categories.work_activity.title'),
    description: i18n.t('employee_form.payroll_data.categories.work_activity.description'),
  },
]
